import { useState } from "react";
import { CrearEntidadForm, Input, NumberInput } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearIndicadorImpuesto } from "../hooks/use-indicadores-impuesto-mutations";

export function IndicadorCrearForm({ onSalir }: { onSalir: () => void }) {
  const [codigo, setCodigo] = useState("");
  const [tasaPct, setTasaPct] = useState<number | "">("");
  const [descripcion, setDescripcion] = useState("");

  const crear = useCrearIndicadorImpuesto({ onCreado: onSalir });

  const submit = () => {
    if (!codigo.trim() || tasaPct === "" || !descripcion.trim()) {
      toastError({ title: "Datos incompletos", message: "Código, tasa y descripción son obligatorios." });
      return;
    }
    crear.mutate({ codigo: codigo.trim().toUpperCase(), tasaOCuota: Number(tasaPct) / 100, descripcion: descripcion.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nuevo indicador"
      descripcion="Código SAP (ej. V0, V5, V7), tasa o cuota expresada en % y descripción visible en los selectores de captura."
      cols={3}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Código" placeholder="V5" value={codigo} onChange={(e) => setCodigo(e.currentTarget.value.toUpperCase())} maxLength={4} className="font-mono" />
      <NumberInput
        label="Tasa o cuota"
        placeholder="16"
        value={tasaPct}
        onChange={(v) => setTasaPct(v)}
        min={0}
        max={100}
        step={0.5}
        decimals={4}
        suffix="%"
      />
      <Input label="Descripción" placeholder="IVA tasa general 16%" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} />
    </CrearEntidadForm>
  );
}
